// page.service.js
import config from 'app/config';

import { saveItem, deleteItemByKey } from './storage.service';

class pageService {

  constructor($http, $location, $state) {
    this.config = config;
    this.$http = $http;
    this.$location = $location;
    this.$state = $state;
  }

  // setup default headers to be used with UC Checkout API.
  headers() {
    return {
      headers: {
        'content-type': 'application/json',
        'Accept' : "application/json",
        'Authorization' : 'Basic b3BtcnM6QmZMek9yWGJzMzNDdE5i'
      }
    }
  }

  // Query Params : read alll the query param and retun as object
  getQueryParamObject() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
  }

  getPage(page) {
    return this.$http.get(this.config.api + page);
  }

  getRow(endpoint) {
    return this.$http.get(this.config.api + endpoint);
  }

  getRowV3(endpoint) {
    return this.$http.get(this.config.apiv3 + endpoint);
  }

  post(endpoint, data) {
    return this.$http.post(this.config.api + endpoint, data);
  }

  postV3(endpoint, data) {
    return this.$http.post(this.config.apiv3 + endpoint, data, this.headers());
  }

  getTC(id) {
    return this.$http.get(this.config.api +'checkout/tc/' + id);
  }

  logTC(data) {
    this.$http.post(this.config.api +'checkout/tc/log', data).then((result) => {
      if(result.data.status == 'ok') {
        saveItem(`${config.appName}_atcid`, result.data);
      }
    })
  }

  traffic(launch) {
    var qParams = this.getQueryParamObject();
    var affId = typeof qParams.AFFID !== "undefined" && qParams.AFFID != true ? qParams.AFFID : 0;
    var data = {affiliate_id: affId, page: this.$state.$current.data.pageTitle, page_url: this.$location.absUrl(), launch: launch}
    this.$http.post(this.config.api + 'partners/log/traffic', data).then((result) => {})
  }

  optin(launch, name, email) {
    var qParams = this.getQueryParamObject();
    var affId = typeof qParams.AFFID !== "undefined" && qParams.AFFID != true ? qParams.AFFID : 0;
    var data = {affiliate_id: affId, page: this.$state.$current.data.pageTitle, page_url: this.$location.absUrl(), launch: launch, name: name, email: email}
    this.$http.post(this.config.api + 'partners/log/optins', data).then((result) => {})
  }

  base64_encode(e) {
      var r, t, c, a, h, n, o, A, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", d = 0, l = 0, s = "", u = [];
      if (!e)
          return e;
      do
          r = e.charCodeAt(d++), t = e.charCodeAt(d++), c = e.charCodeAt(d++), A = r << 16 | t << 8 | c, a = A >> 18 & 63, h = A >> 12 & 63, n = A >> 6 & 63, o = 63 & A, u[l++] = i.charAt(a) + i.charAt(h) + i.charAt(n) + i.charAt(o);
      while (d < e.length);
      s = u.join("");
      var C = e.length % 3;
      var decoded = (C ? s.slice(0, C - 3) : s) + "===".slice(C || 3);
      decoded = decoded.replace("+", "-");
      decoded = decoded.replace("/", "_");
      return decoded;
  }

  updateLogTC(atcid, orderid) {
    var data = {id:atcid, orderid:orderid };
    this.$http.put(this.config.api +'checkout/tc/log', data).then((result) => {
      if(result.data.status == 'ok') {
        console.log('TC Order ID Updated');
        deleteItemByKey(`${config.appName}_atcid`);
      }
    })
  }

  getNextSunday() {
    return this.$http.get(this.config.baseURL +'api.php');
  }

  // getData() {
  //   const REPOS = "users/var-bin/repos";
  //   const URL = `${this.API_URL}/${REPOS}`;
  //
  //   return this.$http.get(URL)
  //     .then((response) => response.data);
  // }
}

pageService.$inject = ["$http", "$location", '$state'];

export { pageService }
